export default __webpack_public_path__ + "static/media/SLIDER-Vimepay.00613356.png";